export default "__VITE_ASSET__06f024aa__"